var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24996 5.33325C5.71866 5.33325 3.66663 7.38529 3.66663 9.91659C3.66663 14.4999 9.08329 18.6666 12 19.6358C14.9166 18.6666 20.3333 14.4999 20.3333 9.91659C20.3333 7.38529 18.2813 5.33325 15.75 5.33325C14.1998 5.33325 12.8294 6.10279 12 7.28067C11.1705 6.10279 9.80008 5.33325 8.24996 5.33325Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveIcon);
export default __webpack_public_path__ + "static/media/loveIcon.a47c66268d7489b92fe478cc9a1c537b.svg";
export { ForwardRef as ReactComponent };